import { createUseStyles } from "react-jss";

export default createUseStyles({
    selectedWord: {
        composes: "selected-word",
        "background-color": "#2366DB",
        color: "#FFFFFF",
    },
    selectedCategory0: ({ category0Color }) => ({
        composes: "selected-category-0",
        "background-color": category0Color,
    }),
    selectedCategory1: ({ category1Color }) => ({
        composes: "selected-category-1",
        "background-color": category1Color,
    }),
    selectedCategory2: ({ category2Color }) => ({
        composes: "selected-category-2",
        "background-color": category2Color,
    }),
    selectedCategory3: ({ category3Color }) => ({
        composes: "selected-category-3",
        "background-color": category3Color,
    }),
    selectedCategory4: ({ category4Color }) => ({
        composes: "selected-category-4",
        "background-color": category4Color,
    }),
    selectedCategory5: ({ category5Color }) => ({
        composes: "selected-category-5",
        "background-color": category5Color,
    }),
    saveButton: {
        composes: "save__button",
        "background-color": "#3AAAEA",
        color: "white",
        "font-family": "Open Sans",
        "font-size": "14px",
        "font-weight": "600",
        "line-height": "19px",
        "letter-spacing": "0em",
        "text-align": "center",
        width: "104.61px",
        height: "33px",
        "border-radius": "8px",
    },
    saveButtonDisabled: {
        composes: "save__button__disabled",
        "background-color": "#F3F3F3",
        color: "#000000",
        "font-family": "Open Sans",
        "font-size": "14px",
        "font-weight": "600",
        "line-height": "19px",
        "letter-spacing": "0em",
        "text-align": "center",
        width: "104.61px",
        height: "33px",
        "border-radius": "8px",
    },
    cancelButton: {
        composes: "cancel__button",
        width: "104.82px",
        height: "33px",
        background: "#F3F3F3",
        "border-radius": "8px",
        color: "#000000",
        "font-weight": "600",
        "font-family": "Open Sans",
    },
    cancelButtonHover: {
        composes: "cancel__button buttonActive",
        color: "black",
    },
    deleteButton: {
        composes: "delete__button",
        width: "104.82px",
        height: "33px",
        background: "#FF006F",
        color: "#FFFFFF",
        "border-radius": "8px",
        "font-weight": "600",
        "font-family": "Open Sans",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
    },
    withFormatDisableUserSelection: {
        display: "flex",
        flexFlow: "wrap",
        WebkitTouchCallout: "none",
        WebkitUserSelect: "none",
        KhtmlUserSelect: "none",
        MozUserSelect: "none",
        msUserSelect: "none",
        userSelect: "none",
    },
    withoutFormatDisableUserSelection: {
        WebkitTouchCallout: "none",
        WebkitUserSelect: "none",
        KhtmlUserSelect: "none",
        MozUserSelect: "none",
        msUserSelect: "none",
        userSelect: "none",
    },
    withoutFormatButtonWrapper: {
        marginRight: "5px",
    },
});
